import { bl_fi_einvoice_purchase_doc_matching_queue_RowClass } from '../../dbschema/bl_fi_einvoice_purchase_doc_matching_queue.model';
import { BaseContainerModel } from '../base-container.model';

export class PurchaseDocMatchingQueueContainerModel extends BaseContainerModel {
    bl_fi_einvoice_purchase_doc_matching_queue: bl_fi_einvoice_purchase_doc_matching_queue_RowClass = new bl_fi_einvoice_purchase_doc_matching_queue_RowClass();
}
